<template>
  <div class="resumoreserva">
    <div v-if="!isLoading" class="mt-2 mb-2">
      <div
        :title="form.payLater ? 'Resumo da Cotação' : 'Resumo da Reserva'"
        style="margin-bottom: 0"
      >
        <div class="accordeon d-flex justify-content-center">
          <input
            type="checkbox"
            name="accordeon-title"
            :checked="!isMobile"
            class="accordeon-checkbox"
            id="accordeon-title"
          />

          <div class="accordeon-content">
            <div class="d-flex justify-content-between">
              <div
                class="mb-2"
                style="color: #000; font-weight: 500;"
              >
                Resumo da {{ form.payLater ? 'Cotação' : 'Reserva' }}
              </div>

              <h3 v-if="totalCost > 0" class="valorresumo">
                <b
                  >{{
                    Number(totalCost).toLocaleString('pt-br', {
                      style: 'currency',
                      currency: 'BRL',
                    })
                  }}
                </b>
              </h3>

              <label
                for="accordeon-title"
                class="accordeon-title-label"
              ></label>
            </div>

            <div class="d-flex mt-2" align-h="between">
              <div>
                <h5 style="font-size: 80%">Tipo:</h5>
              </div>

              <div>
                <h5 style="font-weight: 400; margin-left: 10px">
                  {{ form.booking_name }}
                </h5>
              </div>
            </div>

            <div class="d-flex" align-h="between">
              <div>
                <h5 style="font-size: 80%">
                  Agendado para:
                </h5>
              </div>

              <div>
                <h5 style="font-weight: 400; margin-left: 10px">
                  {{
                    formattedDate +
                    (form.time != '00:00' ? ' ' + form.time : '')
                  }}
                </h5>
              </div>
            </div>

            <div class="insidereservainfo" style="margin-bottom: 0">
              <div
                v-for="(ticket, idx) in form.tickets"
                :key="idx"
                style="margin-bottom: 0"
              >
                <div class="d-flex" v-if="ticket.quantity > 0" align-h="around">
                  <div>
                    <h5 style="color: #525f7f">
                      {{ ticket.label + ' (x ' + ticket.quantity + ')' }}
                    </h5>
                  </div>

                  <div class="ml-auto">
                    <h5 style="color: #525f7f">
                      {{ formatTicketValues(ticket) }}
                    </h5>
                  </div>
                </div>

                <b-row
                  v-if="ticket.quantity > 0"
                  class="container"
                  style="margin-bottom: 2%"
                >
                  <small class="h6" style="margin-bottom: 0; color: #525f7f">
                    {{
                      ticket.description != undefined &&
                      ticket.description != null &&
                      ticket.description.length > 0
                        ? ticket.description
                        : ''
                    }}
                  </small>
                </b-row>
              </div>

              <hr style="margin-top: 1%; margin-bottom: 5%" />

              <div>
                <b-row style="margin-bottom: 0">
                  <b-col v-if="totalCost > 0" class="text-right">
                    <h3>
                      <b
                        >{{
                          Number(totalCost).toLocaleString('pt-br', {
                            style: 'currency',
                            currency: 'BRL',
                          })
                        }}
                      </b>
                    </h3>
                  </b-col>
                  <b-col v-else class="text-right">
                    <h4>
                      <span>Agendamento gratuito </span>
                    </h4>
                  </b-col>
                </b-row>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'
import { isMobile } from '@/store/utils/general'
import useManageReservaExpressaInjection from '../../Composables/useManageReservaExpressa'

export default {
  name: 'ResumoReserva',

  setup(props, context) {
    const manageReservaExpressa = useManageReservaExpressaInjection(context)

    function calculateTotalCost() {
      return manageReservaExpressa.calculateTotalCost()
    }
    function setTickets(items) {
      return manageReservaExpressa.setTickets(items)
    }
    function setSelectedSpecialBookingType(item) {
      return manageReservaExpressa.setSelectedSpecialBookingType(item)
    }

    return {
      calculateTotalCost,
      setTickets,
      setSelectedSpecialBookingType,
    }
  },

  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapGetters('booking', {
      form: 'getReservaForm',
    }),

    //TODO use utils.general.formatDate
    formattedDate() {
      return moment(this.form.date).format('DD/MM/YYYY')
    },

    totalCost() {
      return this.calculateTotalCost()
    },
  },

  watch: {
    ['form.tickets'](newValue, oldValue) {
      this.setTickets(newValue)
    },
  },

  data() {
    return {
      isMobile: isMobile(),
    }
  },

  methods: {
    ...mapActions('booking', ['bookingStoreCommit']),

    formatTicketValues(ticket) {
      const price = Number(ticket.price.replace(',', '.'))
      const quantity = Number(ticket.quantity)
      return 'R$ ' + (price * quantity).toFixed(2).replace('.', ',')
    },
  },

  mounted() {
    this.setTickets(this.form.tickets)
  },
}
</script>

<style>
/* Checkbox de controle para o acordeão */
.accordeon-checkbox {
  display: none;
}

/* Estilo para o título do acordeão */
.accordeon-title-label {
  float: right;
  cursor: pointer;
  display: block;
  color: #b49d61;
  font-weight: bold;
  font-family: Arial, sans-serif;
  /*   width: 10px;
    height: 10px; */
}

.accordeon-title-label:before {
  content: '\ea17';
  font-family: 'Nucleo';
  font-weight: 700;
  line-height: 0;
}

/* Conteúdo do acordeão */
.accordeon-content {
  width: 270px;
  display: grid;
  /* justify-content:center; */
  height: 30px;
  overflow: hidden;
  -webkit-transition: height 0.9s ease;
  transition: height 0.9s ease;
  padding-left: 10px;
}

/* Estilo aplicado quando o checkbox está selecionado */
.accordeon-checkbox:checked + .accordeon-content {
  height: fit-content;
  .valorresumo {
    display: none;
  }
}

.accordeon-checkbox:checked + .accordeon-content .accordeon-title-label:before {
  font-family: 'Nucleo';
  content: '\ea43';
  font-weight: 700;
  line-height: 0;
}

.resumoreserva {
  min-width: 90%;
  height: fit-content;
  background: #ffffff;
  border: 1px solid #dbdbdb;
  border-radius: 12px;
  padding: 10px;
  margin-left: 15px;
}

.insidereservainfo {
  width: 250px;
  height: auto;
  background: #f9f9f9;
  border: 1px solid #dbdbdb;
  border-radius: 12px;
  padding: 10px;
  margin-top: 10px;
}

@media screen and (max-width: 870px) {
  .resumoreserva {
    margin-bottom: 65px;
    margin-left: 0;
    left: 5%;
    position: fixed;
    bottom: 0;
  }
}

@media screen and (max-width: 870px) {
  .accordeon-title-label:before {
    content: '\ea43';
    font-family: 'Nucleo';
    font-weight: 700;
    line-height: 0;
  }

  .accordeon-checkbox:checked
    + .accordeon-content
    .accordeon-title-label:before {
    font-family: 'Nucleo';
    content: '\ea17';
    font-weight: 700;
    line-height: 0;
  }

  .accordeon-content {
    width: 290px;
    display: grid;
    /* justify-content:center; */
    height: 30px;
    overflow: hidden;
    -webkit-transition: height 0.9s ease;
    transition: height 0.9s ease;
  }
}
</style>
